import React from 'react'
import PrivacyPolicy from '../privacy-policy'

const PrivacyPolicyEn = () => {
    return <PrivacyPolicy languageCode="en" />
}

export default PrivacyPolicyEn
